import { EVENT_NAMES } from '@aqx-core/common/utils/event/constants';
import { eventEmitter } from '@aqx-core/common/utils/event/event-emitter';

// Notify other watchlist instance to refresh the list
export const dispatchRefetchCurrentList = () => {
  eventEmitter.emit(EVENT_NAMES.REFETCH_CURRENT_LIST);
};
